export const faqConstants = {
    ADD_FAQ_REQUEST:              'ADD_FAQ_REQUEST',
    ADD_FAQ_SUCCESS:              'ADD_FAQ_SUCCESS',
    ADD_FAQ_FAILURE:              'ADD_FAQ_FAILURE',

    GET_FAQ_LIST_REQUEST:         'GET_FAQ_LIST_REQUEST',
    GET_FAQ_LIST_SUCCESS:         'GET_FAQ_LIST_SUCCESS',
    GET_FAQ_LIST_FAILURE:         'GET_FAQ_LIST_FAILURE',

    GET_FAQ_DETAILS_REQUEST:      'GET_FAQ_DETAILS_REQUEST',
    GET_FAQ_DETAILS_SUCCESS:     'GET_FAQ_DETAILS_SUCCESS',
    GET_FAQ_DETAILS_FAILURE:      'GET_FAQ_DETAILS_FAILURE',

    UPDATE_FAQ_DETAILS_REQUEST:   'UPDATE_FAQ_DETAILS_REQUEST',
    UPDATE_FAQ_DETAILS_SUCCESS:  'UPDATE_FAQ_DETAILS_SUCCESS',
    UPDATE_FAQ_DETAILS_FAILURE:   'UPDATE_FAQ_DETAILS_FAILURE',

    DELETE_FAQ_REQUEST:           'DELETE_FAQ_REQUEST',
    DELETE_FAQ_SUCCESS:           'DELETE_FAQ_SUCCESS',
    DELETE_FAQ_FAILURE:           'DELETE_FAQ_FAILURE',

    GET_FAQ_FRONTEND_DETAILS_REQUEST:'GET_FAQ_FRONTEND_DETAILS_REQUEST',
    GET_FAQ_FRONTEND_DETAILS_SUCCESS:'GET_FAQ_FRONTEND_DETAILS_SUCCESS',
    GET_FAQ_FRONTEND_DETAILS_FAILURE:'GET_FAQ_FRONTEND_DETAILS_FAILURE',

    ADD_FAQ_VOTE_REQUEST:'ADD_FAQ_VOTE_REQUEST',
    ADD_FAQ_VOTE_SUCCESS:'ADD_FAQ_VOTE_SUCCESS',
    ADD_FAQ_VOTE_FAILURE:'ADD_FAQ_VOTE_FAILURE',

    GET_FAQ_VOTE_DETAILS_REQUEST:'GET_FAQ_VOTE_DETAILS_REQUEST',
    GET_FAQ_VOTE_DETAILS_SUCCESS:'GET_FAQ_VOTE_DETAILS_SUCCESS',
    GET_FAQ_VOTE_DETAILS_FAILURE:'GET_FAQ_VOTE_DETAILS_FAILURE'
    
 };


// WEBPACK FOOTER //
// ./src/app/redux/constants/faqConstants.js